import { UAParser } from 'ua-parser-js'

export class PlatformUtil {

    static isWindows() {
        const ua = new UAParser()
        return ua.getOS().name === 'Windows'
    }
}
